export default "__VITE_ASSET__BLHawdZK__"